import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'
import { INSTANCES_QUERY_KEY, INSTANCES_URL } from './queryConstants'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import { YEAR_FIRST_DATE_FORMAT } from '../utils.datetime'

dayjs.extend(isoWeek)

type UseInstancesListReturn = {
  instances: any
  isLoading: boolean
  metadata: { unassignedHours: number }
}

type UseInstancesListProps = {
  selectedDate?: Date
  intervalType?: 'daily' | 'weekly'
  otherFilterParams?: Record<string, any>
}

const useInstancesList = ({
  selectedDate,
  intervalType,
  otherFilterParams = {},
}: UseInstancesListProps): UseInstancesListReturn => {
  const date =
    intervalType === 'weekly'
      ? dayjs(selectedDate).startOf('isoWeek').format(YEAR_FIRST_DATE_FORMAT)
      : dayjs(selectedDate).format(YEAR_FIRST_DATE_FORMAT)

  const params = getQueryParams({
    date,
    intervalType,
    ...otherFilterParams,
  })

  const { isLoading, data: instances } = useQuery(
    [INSTANCES_QUERY_KEY, params],
    () =>
      getJSON({
        url: `${INSTANCES_URL}?${params}`,
        isRota: true,
      }),
    {
      enabled: !!selectedDate && !!intervalType,
      retry: false,
    }
  )

  return {
    instances: instances?.data || [],
    isLoading,
    metadata: instances?.metadata,
  }
}

export default useInstancesList
